<template>
    <div>
        <div v-show="!mostrarDetalheFaseContrato">
            <b-alert show>
                <span>
                    Total do Contrato:
                    <strong>
                        {{ contrato.nuValorGlobalContrato | currency }}
                    </strong>
                </span>
                <br />
                <span>
                    Total das Fases:
                    <strong>{{ contrato.totalFases | currency }}</strong>
                </span>
                <br />
                <span>
                    Sem Registro:
                    <strong>
                        {{ contrato.valorDisponivelFases | currency }}
                    </strong>
                </span>
                <br />
            </b-alert>
            <app-tabela
                idTabela="tblFasesContrato"
                :itens="contrato.fasesContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <btn-inserir-fase-contrato
                            :apostilamento="apostilamento()"
                            :contrato="contrato"
                            @obterFasesAtualizadas="
                                $emit('obterFasesAtualizadas')
                            "
                            v-if="mostrarBtnInserirFase"
                        ></btn-inserir-fase-contrato>
                    </b-button-group>
                </template>
                <template slot="acoes" slot-scope="data">
                    <span
                        class="text-primary"
                        v-if="mostrarBtnDetalharFase(data)"
                    >
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar Fase"
                            @click.stop="
                                detalharFaseContrato(data.faseContratoId)
                            "
                        ></i>
                    </span>
                    <btn-atualizar-fase-contrato
                        :fase="data"
                        :apostilamento="apostilamento()"
                        :contrato="contrato"
                        v-if="mostrarBtnAtualizarFase"
                        @obterFasesAtualizadas="$emit('obterFasesAtualizadas')"
                    ></btn-atualizar-fase-contrato>
                    <btn-excluir-fase
                        :fase="data"
                        :apostilamento="apostilamento()"
                        :contrato="contrato"
                        v-if="mostrarBtnExcluirFase(data)"
                        @obterFasesAtualizadas="$emit('obterFasesAtualizadas')"
                    ></btn-excluir-fase>
                    <btn-consumo-por-item
                        :fase="data"
                    ></btn-consumo-por-item>
                </template>
                <template slot="requerAprovacao" slot-scope="data">
                    <app-status
                        :status="data.requerAprovacao ? 'SIM' : 'NÃO'"
                    ></app-status>
                </template>
                <template slot="valor" slot-scope="data">
                    <p class="text-right m-0">{{ data.valor | currency }}</p>
                </template>
                <template slot="saldo" slot-scope="data">
                    <p class="text-right m-0">{{ data.saldo | currency }}</p>
                </template>
                <template slot="saldoReal" slot-scope="data">
                    <p class="text-right m-0">{{ data.saldoReal | currency }}</p>
                </template>
                <template slot="disponivel" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.disponivel | currency }}
                    </p>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarDetalheFaseContrato">
            <app-detalhes-fase-contrato
                :faseContrato="faseContrato"
                :apostilamento="apostilamento()"
                :contrato="contrato"
                :contratoElaboracao="contratoElaboracao()"
                :aditivoContratoIniciado="aditivoContratoIniciado()"
                @fecharDetalhesFaseContrato="faseContrato = null"
                @obterFasesAtualizadas="$emit('obterFasesAtualizadas')"
                @obterComprometimentosAtualizados="
                    $emit('obterComprometimentosAtualizados')
                "
            ></app-detalhes-fase-contrato>
        </div>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import DetalhesFaseContrato from './DetalhesFaseContrato'
import BtnAtualizarFaseContrato from './BtnAtualizarFaseContrato'
import BtnExcluirFase from './BtnExcluirFase'
import BtnInserirFaseContrato from './BtnInserirFaseContrato'
import { situacaoContrato } from '../SituacaoContrato'
import BtnConsumoPorItem from './BtnConsumoPorItem'

export default {
    components: {
        AppDetalhesFaseContrato: DetalhesFaseContrato,
        BtnAtualizarFaseContrato,
        BtnExcluirFase,
        BtnInserirFaseContrato,
        BtnConsumoPorItem
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            faseContrato: null,
            campos: [
                {
                    key: 'tipoFaseContrato',
                    label: 'Tipo da Fase',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dataInicioVigencia',
                    label: 'Vigência Início',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'dataFimVigencia',
                    label: 'Vigência Fim',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'requerAprovacao',
                    label: 'Requer Aprovação',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'saldo',
                    label: 'Saldo Previsto',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'saldoReal',
                    label: 'Saldo Real',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'disponivel',
                    label: 'Sem Registro',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'itemContrato',
                    label: 'Item Contrato',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        mostrarBtnDetalharFase(fase) {
            return (
                fase.tipoFaseContratoId === 1 || fase.tipoFaseContratoId === 2
            )
        },

        detalharFaseContrato(faseContratoId) {
            this.faseContrato = this.contrato.fasesContrato.filter(item => {
                return item.faseContratoId === faseContratoId
            })[0]
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-06') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        mostrarBtnExcluirFase(fase) {
            if (
                fase.tipoFaseContratoId === 1 ||
                fase.tipoFaseContratoId === 2
            ) {
                return (
                    ((this.apostilamento() && !fase.temDetalhamento) ||
                        (this.contratoElaboracao() && !fase.temDetalhamento) ||
                        (this.aditivoContratoIniciado() &&
                            !fase.temDetalhamento)) &&
                    this.controleHistoricoAditivos()
                )
            } else {
                return (
                    ((this.apostilamento() && !fase.temComprometimento) ||
                        (this.contratoElaboracao() &&
                            !fase.temComprometimento) ||
                        (this.aditivoContratoIniciado() &&
                            !fase.temComprometimento)) &&
                    this.controleHistoricoAditivos()
                )
            }
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        }
    },

    created() {},

    computed: {
        mostrarDetalheFaseContrato() {
            return this.faseContrato !== null
        },

        mostrarBtnAtualizarFase() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnInserirFase() {
            return (
                ((this.apostilamento() &&
                    this.contrato.valorDisponivelFases > 0) ||
                    (this.contratoElaboracao() &&
                        this.contrato.valorDisponivelFases > 0) ||
                    (this.aditivoContratoIniciado() &&
                        this.contrato.valorDisponivelFases > 0) ||
                    (this.atualizacaoContrato() &&
                        this.contrato.valorDisponivelFases > 0)) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {}
}
</script>
